import React, { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { Container, Icon } from "semantic-ui-react"
const AdminBreadCrumb = () => {
    const location = useLocation()
    const [breadTagName, setBreadTagName] = useState('HOME')
    const userRole = sessionStorage.getItem("userRole")
    const isEntrepreneurAdmin = userRole === "entrepreneur_admin"

    useEffect(() => {
        const { pathname } = location
        if (pathname === '/admin/assessment-users') {
            setBreadTagName(isEntrepreneurAdmin ? 'ASSESSMENT USERS' : 'ASSESSMENT REPORTING')
        }
        else if (pathname === '/admin/assessment-details') {
            setBreadTagName('ASSESSMENT DETAILS')
        }
        else if (pathname === '/admin/report') {
            setBreadTagName('REPORTING')
        }
        else if (pathname === '/admin/settings') {
            setBreadTagName('SETTINGS')
        }
        else if (pathname === '/admin') {
            setBreadTagName('')
        }
        else if (pathname === '/reporting/assessment') {
            setBreadTagName('ASSESSMENT REPORTING')
        }
        else if (pathname === '/admin/game_dashboard') {
            setBreadTagName('GAMES DASHBOARD')
        }
        else if (pathname === '/reporting/games') {
            setBreadTagName('GAMES REPORTING')
        }
        else if (pathname === '/recent_registrations') {
            setBreadTagName('NEW REGISTRATIONS')
        }
        else if (pathname === '/researchers') {
            setBreadTagName('RESEARCHERS')
        }
        else if (pathname === '/survey-data') {
            setBreadTagName('SURVEY DATA')
        }
        else if (pathname === '/organization-management') {
            setBreadTagName('Organization Management')
        }
        else if (pathname === '/admin/questions-answers') {
            setBreadTagName('QUESTION AND ANSWER')
        }
        else if (pathname === '/admin/access-codes') {
            setBreadTagName('ACCESS CODES')
        }
        else if (pathname === '/admin/master-access-codes' || pathname === '/admin/master-access-code') {
            setBreadTagName('MASTER ACCESS CODES')
        }
        else if (pathname === '/admin/contact-us-queries') {
            setBreadTagName('CONTACTS US QUERIES')
        }
        else if (pathname === '/admin/access-requests') {
            setBreadTagName('ACCESS REQUESTS')
        }
        else {
            setBreadTagName('GAMES DATA')
        }
        // eslint-disable-next-line
    }, [location.pathname])



    return (
        <div id={"udc-breadcrumb"} className={"bg-breadcrumb"} style={{ top: "24px" }}>
            <Container >
                <div className="ui breadcrumb">
                    <Link to={isEntrepreneurAdmin ? "/admin/assessment-users" : "/admin"} className="section">
                        <Icon name="home" />Home
                    </Link>
                    {
                        location.pathname !== "/admin" && <>
                            <i className="right angle icon divider"></i>
                            <Link to={"#"} className="section">{breadTagName}</Link>
                        </>
                    }
                </div>
            </Container>
        </div>
    )
}

export default AdminBreadCrumb
